import { environment } from '../../../../environments/environment';
import {
  projectPath,
  projectTaskPath,
} from '../../../cross-team-shared/hub-paths';

export function clientFeedbackPath(
  projectId: number,
  taskId: string,
  id?: string,
) {
  return `${environment.clientCalibrationBaseUrl}${projectTaskPath(
    projectId,
    taskId,
  )}/issues${id ? '/' + id : ''}`;
}

export function createClientFeedbackPath(
  projectId: number,
  taskId: string,
  id?: string,
) {
  return `${clientFeedbackPath(
    projectId,
    taskId,
    id,
  )}?join=attachments&join=comments`;
}

export function getClientFeedbackPath(projectId: number, taskId: string) {
  return `${clientFeedbackPath(
    projectId,
    taskId,
  )}?join=attachments&join=comments&join=comments.attachments&sort=createdAt,DESC`;
}

export function clientFeedbackAttachmentsPath(
  projectId: number,
  taskId: string,
  issueId: string,
) {
  return `${clientFeedbackPath(
    projectId,
    taskId,
    issueId,
  )}/attachments/presigned-urls`;
}

export function clientFeedbackCommentPath(
  projectId: number,
  taskId: string,
  issueId: string,
) {
  return `${clientFeedbackPath(projectId, taskId)}/${issueId}/comments`;
}

export function commentAttachmentsPath(
  projectId: number,
  taskId: string,
  issueId: string,
) {
  return `${clientFeedbackCommentPath(
    projectId,
    taskId,
    issueId,
  )}/attachments/presigned-urls`;
}

export function clientFeedbackTagsPath(projectId: number) {
  return `${environment.clientCalibrationBaseUrl}${projectPath(
    projectId,
  )}/issues/tags`;
}

export function clientFeedbackResolveWithComment(
  projectId: number,
  taskId: string,
  issueId: string,
) {
  return `${clientFeedbackPath(projectId, taskId, issueId)}/resolve`;
}
